import { createContentfulComponent } from "frontend/contentful/lib/create-contentful-component";
import { PodcastPlayerEntry } from "frontend/contentful/schema/blocks";
import { PodcastPlayer } from "design-system/components/blocks/podcast-player/podcast-player";
import { createPodcastPlayerProps } from "./podcast-player.props";

export const ContentfulPodcastPlayer =
  createContentfulComponent<PodcastPlayerEntry>(({ entry }) => {
    const props = createPodcastPlayerProps(entry);

    return <PodcastPlayer {...props} />;
  });
